var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.68447 228.42 29.784 143.14c0.97876 4.704 5.5855 7.7239 10.29 6.7451l64.512-13.423c4.704-0.97882 9.3108 2.0411 10.29 6.7451l25.946 124.7c0.97871 4.704 5.5855 7.724 10.29 6.7452l72.279-15.039c4.704-0.97871 7.724-5.5855 6.7452-10.29l-25.946-124.7c-0.97873-4.704 1.9442-9.6853 6.5618-11.013 37.698-10.837 150.27-45.86 254.76 2.129 4.3658 2.0048 11.257 5.8258 15.926 6.9076 76.55 17.738-14.281-370.34-70.608-340.71-4.225 2.2221-9.2276 8.4627-12.553 11.931-123.56 128.86-224.41 160.86-391.53 195.84-4.7028 0.98426-7.7229 5.5902-6.7441 10.294z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.28f5dc01bcabbfd2de3e31d65e3d4542.svg";
export { ForwardRef as ReactComponent };